export default __webpack_public_path__ + "static/media/m_background-left.80dcab0f.png";